import { useQuery } from "react-query";
import get from "lodash/get";

import * as Api from "../api";
import * as Constants from "../constants";
import * as Mappers from "../mappers";

const useServiceDocs = ({ orgId, search } = {}) => {
  const initialData = [];

  const { data = initialData, ...args } = useQuery(
    [Constants.ENTITY, "service-docs", orgId, search],
    async () => {
      const { data } = await Api.ServiceDocs(
        orgId ? { organizationId: orgId } : {},
      );

      return (get(data, "data") || []).map(Mappers.ServiceDocs);
    },
    {
      initialData,
    },
  );

  return {
    data,
    ...args,
  };
};

export default useServiceDocs;
